import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class ValidationResultsService {

    // Observable sources
    private sendCountToChild = new Subject<any>();
    private toggleParent = new Subject<any>();

    // Observable streams
    sendCount$ = this.sendCountToChild.asObservable();
    toggle$ = this.toggleParent.asObservable();

    // Service message commands
    sendCount(count: any) {
        this.sendCountToChild.next(count);
    }

    toggle(show: any) {
        this.toggleParent.next(show);
    }
}
